<template>
    <div v-if="$route.name=='Login'"></div>
    <div v-else-if="$route.name=='POS'"></div>
    <div v-else>     
      <ToolTop />
      <MenuBar />
      <Breadcrumbs />
      <!-- <Breadcrumbs @sword-id="getWord($event)" /> -->
      <!-- <FieldSearchWord  :priceid="priceid" @refresh-id="refreshPage($event)" /> -->
    </div>    
</template>

<script>
import {mapState} from "vuex";
//import SearchProducts from "./components/SearchProducts.vue";
import ToolTop from "@/components/ToolTop";
import MenuBar from '@/components/MenuBar';
import Breadcrumbs from '@/components/Breadcrumbs';
// import Footer from "@/components/Footer";

export default{
    name:'defaultLayout',
    computed:{
        ...mapState(["loading",'currentUser'])
    },
    components:{    
        //Productos,
        ToolTop,
        MenuBar,
        Breadcrumbs,
        // Footer,
        //SearchProducts
    },
    methods:{
      getWord(event){
        this.swordid=event
        alert(this.swordid)
      }
    },
    data: () => ({           
      swordid:'',
    })
}
</script>